import { transformImageUrl } from 'src/utils/image/transformImageUrl';

export function transformImageUrlMenuItem(imageUrl?: string): string {
    return transformImageUrl(imageUrl, 1280);
}
